"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoPlugin = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Link_1 = require("@skbkontur/react-ui/components/Link");

var bowser_1 = tslib_1.__importDefault(require("bowser"));

var _1 = require(".");

exports.NoPlugin = function (_a) {
  var pluginInstallLink = _a.pluginInstallLink,
      installPluginOnNewTab = _a.installPluginOnNewTab,
      addToTrustedLink = _a.addToTrustedLink,
      trackEvent = _a.trackEvent,
      _b = _a.needUpdate,
      needUpdate = _b === void 0 ? false : _b;
  var metricsAction = needUpdate ? _1.DisplayedErrorCodes.ObsoletePluginVersion : _1.DisplayedErrorCodes.NoPlugin;
  var target = installPluginOnNewTab ? '_blank' : '_self';

  if (!installPluginOnNewTab) {
    pluginInstallLink += "?back=" + encodeURIComponent(location.href);
  }

  var onPluginInstallClick = function onPluginInstallClick() {
    trackEvent(metricsAction, 'pluginInstallLinkClick');
  };

  var onAddToTrustedClick = function onAddToTrustedClick() {
    trackEvent(_1.DisplayedErrorCodes.NoPlugin, 'addToTrustedLinkClick');
  };

  var actionName = needUpdate ? 'Обновите' : 'Установите'; // При обновлении Плагина, не нужно запускать файл настройки AddToTrusted, а это единственное чем отличается
  // версия выводимая для IE, поэтому отключаем ее.

  var showIEVersion = bowser_1.default.msie && !needUpdate;
  var message = showIEVersion ? react_1.default.createElement("div", null, "1.\xA0", actionName, ' ', react_1.default.createElement(Link_1.Link, {
    "data-tid": "pluginInstallLink",
    onClick: onPluginInstallClick,
    href: pluginInstallLink,
    target: target
  }, "\u041A\u043E\u043D\u0442\u0443\u0440.\u041F\u043B\u0430\u0433\u0438\u043D"), ".", react_1.default.createElement("br", null), "2.\xA0\u0417\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u0435", ' ', react_1.default.createElement(Link_1.Link, {
    "data-tid": "addToTrustedLink",
    onClick: onAddToTrustedClick,
    href: addToTrustedLink
  }, "\u0444\u0430\u0439\u043B \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438"), ' ', "\u0438\u043B\u0438\xA0\u043F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u0431\u0440\u0430\u0443\u0437\u0435\u0440.", react_1.default.createElement("br", null), "\u0415\u0441\u043B\u0438 \u043D\u0435\xA0\u043F\u043E\u043C\u043E\u0433\u043B\u043E, \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 \u0442\u0435\u0445\u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443.") : react_1.default.createElement("div", null, actionName, ' ', react_1.default.createElement(Link_1.Link, {
    "data-tid": "pluginInstallLink",
    onClick: onPluginInstallClick,
    href: pluginInstallLink,
    target: target
  }, "\u041A\u043E\u043D\u0442\u0443\u0440.\u041F\u043B\u0430\u0433\u0438\u043D"), ".", react_1.default.createElement("br", null), "\u0415\u0441\u043B\u0438 \u043D\u0435\xA0\u043F\u043E\u043C\u043E\u0433\u043B\u043E, \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 \u0442\u0435\u0445\u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443.");
  return {
    title: 'Настройте компьютер',
    message: message
  };
};